(() => {
  angular.module('pims').filter('discount', () => {
    return discount => {
      if (!discount) {
        return;
      }

      if (discount.type == 'percent') {
        return `${discount.value * 100}%`;
      } else if (discount.type == 'dollar') {
        return `$${discount.value}`;
      }
    };
  });
})();